<script setup>
import { Loc } from 'main.core';

const props = defineProps({
  label: {
    type: String,
    default: '',
  },

  min: {
    type: Number,
    default: 1,
  },
});

const model = defineModel({ required: true });

const increase = event => {
  model.value += 1;
  event.target.blur();
};

const decrease = event => {
  if (model.value > props.min) {
    model.value -= 1;
  }
  event.target.blur();
};
</script>

<template>
  <div class="cloud-calculator__number-input">
    <button
      type="button"
      :title="Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_BUTTON_MINUS')"
      :disabled="model === min"
      @click="decrease"
    >
      &minus;
    </button>
    <input type="number" v-model.number="model" :min="min">
    <button type="button" :title="Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_BUTTON_PLUS')" @click="increase">
      &plus;
    </button>
    <span v-if="label">{{ label }}</span>
  </div>
</template>
